import React from 'react';
import { Form, Input, Select, Button, Row, Col } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;
const { TextArea } = Input;

const AllergiesSection = () => {
  const { t } = useTranslation();

  return (
    <Form.List name="allergies">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'substance']}
                    label={t('intake.medicalHistory.allergies.fields.substance')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.allergies.validation.substanceRequired') },
                      { max: 100, message: t('intake.medicalHistory.allergies.validation.substanceMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.allergies.placeholders.substance')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'type']}
                    label={t('intake.medicalHistory.allergies.fields.type')}
                    initialValue="Other"
                  >
                    <Select>
                      <Option value="Drug">{t('intake.medicalHistory.allergies.types.drug')}</Option>
                      <Option value="Food">{t('intake.medicalHistory.allergies.types.food')}</Option>
                      <Option value="Environmental">{t('intake.medicalHistory.allergies.types.environmental')}</Option>
                      <Option value="Other">{t('intake.medicalHistory.allergies.types.other')}</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'severity']}
                    label={t('intake.medicalHistory.allergies.fields.severity')}
                    initialValue="Unknown"
                  >
                    <Select>
                      <Option value="Mild">{t('intake.medicalHistory.allergies.severity.mild')}</Option>
                      <Option value="Moderate">{t('intake.medicalHistory.allergies.severity.moderate')}</Option>
                      <Option value="Severe">{t('intake.medicalHistory.allergies.severity.severe')}</Option>
                      <Option value="Life-threatening">{t('intake.medicalHistory.allergies.severity.lifeThreatening')}</Option>
                      <Option value="Unknown">{t('intake.medicalHistory.allergies.severity.unknown')}</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={4}>
                  <div className="remove-item-button" style={{ marginTop: '30px' }}>
                    <Button
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      onClick={() => remove(name)}
                    >
                      {t('intake.medicalHistory.allergies.buttons.remove')}
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24}>
                  <Form.Item
                    {...restField}
                    name={[name, 'reaction']}
                    label={t('intake.medicalHistory.allergies.fields.reaction')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.allergies.validation.reactionRequired') },
                      { max: 300, message: t('intake.medicalHistory.allergies.validation.reactionMaxLength') }
                    ]}
                  >
                    <TextArea
                      rows={2}
                      placeholder={t('intake.medicalHistory.allergies.placeholders.reaction')}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.allergies.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noAllergies')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default AllergiesSection;
